import { useTranslation } from 'react-i18next';

export default function ServiceSection() {
  const { t } = useTranslation();

  // const services = [
  //   {
  //     icon: 'ri-user-search-line',
  //     title: t('service.dispatch.title'),
  //     description: t('service.dispatch.desc'),
  //     bgColor: 'bg-trust-navy/5',
  //     iconColor: 'text-trust-navy',
  //   },
  // ];

  return (
    <section id="service" className="py-16 md:py-24 bg-surface-light">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-trust-navy tracking-tight font-jp">
            {t('service.title')}
          </h2>
          <div className="mt-3 w-12 h-0.5 bg-warm-accent mx-auto" />
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="group bg-white rounded-lg p-6 md:p-8 border border-dashed border-gray-300">
            <div className="w-14 h-14 rounded-lg bg-gray-100 flex items-center justify-center mb-5">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-time-line text-gray-400 text-xl" />
              </div>
            </div>
            <h3 className="text-lg md:text-xl font-bold text-gray-400 mb-3 font-jp">
              Coming Soon
            </h3>
            <p className="text-sm md:text-base text-gray-400 leading-relaxed font-jp">
              新しいサービスを準備中です。今しばらくお待ちください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}